import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const NotPageFound = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: isDarkMode ? '#212529' : '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        transition: 'background-color 0.3s ease'
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          {/* Error Number with Overlay Effect */}
          <Box sx={{ mb: 4, position: 'relative' }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '6rem', sm: '8rem', md: '12rem' },
                fontWeight: 800,
                color: isDarkMode ? '#333333' : '#f5f5f5',
                userSelect: 'none',
                lineHeight: 1,
                transition: 'color 0.3s ease'
              }}
            >
              {"404"}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: { xs: '4rem', sm: '6rem', md: '8rem' },
                fontWeight: 800,
                color: '#293d90',
                lineHeight: 1,
                textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              {"404"}
            </Typography>
          </Box>

          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: isDarkMode ? '#ffffff' : '#0F202B',
              mb: 2,
              transition: 'color 0.3s ease'
            }}
          >
            {"Page Not Found"}
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              color: isDarkMode ? '#e0e0e0' : '#4b5563',
              mb: 4,
              maxWidth: '28rem',
              mx: 'auto',
              transition: 'color 0.3s ease'
            }}
          >
            {"The page you are looking for does not exist or has been moved."}
          </Typography>

          {/* Button Container */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              justifyContent: 'center'
            }}
          >
            <Button
              component={Link}
              to="/"
              variant="contained"
              size="large"
              startIcon={<Home />}
              sx={{
                px: 3,
                py: 1.5,
                backgroundColor: '#106423',
                borderRadius: 30,
                boxShadow: 2,
                fontWeight: 'medium',
                textTransform: 'none',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#0c531f',
                  boxShadow: 3,
                  '& .MuiButton-startIcon': {
                    transform: 'scale(1.1)',
                    transition: 'transform 0.2s ease-in-out'
                  }
                },
                '& .MuiButton-startIcon': {
                  transition: 'transform 0.2s ease-in-out'
                }
              }}
            >
              {"Go to Home"}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NotPageFound;